<template>
  <div class="uppgifter">
    <div class="back-nav">
      <router-link :to="{ name: 'elpris' }" class="step-nav__link back-button"><Arrow /> Tillbaka</router-link>
    </div>
    <h1 class="uppgifter__title"><b>Mina uppgifter</b> 1/2</h1>
    <form @submit.prevent="submit">
      <div class="uppgifter__block">
        <h2 class="uppgifter__block-title">Avtalsstart</h2>
        <p class="uppgifter__block-subtitle">Du kan välja att påbörja ditt avtal tidigast den 1:a nästkommande månad eller välja startdatum själv om du t.ex. ska flytta. Glöm inte att kontrollera när ditt avtal löper ut hos din nuvarande leverantör.</p>
        <div class="uppgifter__field-wrapper">
          <input type="radio" v-model="asap" name="asap" required :value="true" id="asap-true" class="uppgifter__field">
          <div class="uppgifter__field-content">
            <label for="asap-true" class="uppgifter__field-label">Jag vill starta avtal snarast möjligast</label>
          </div>
        </div>
        <div class="uppgifter__field-wrapper uppgifter__field-wrapper--asap-false">
          <input type="radio" v-model="asap" name="asap" required :value="false" id="asap-false" class="uppgifter__field">
          <div class="uppgifter__field-content">
            <label for="asap-false" class="uppgifter__field-label">Jag vill starta avtalet ifrån</label>
            <div class="uppgifter__field-extra" v-if="!asap">
              <datepicker v-model="$root.start"
                :disabled-dates="{ to: new Date() }"
                :language="sv"
                required
                id="uppgifter__calendar--start"
                calendar-class="uppgifter__calendar"
                input-class="uppgifter__date-field"
                wrapper-class="uppgifter__calendar-wrapper">
                  <label slot="afterDateInput" class="uppgifter__calendar-action" ref="calendarAction" for="uppgifter__calendar--start">{{start_text}}<Calendar /></label>
              </datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="uppgifter__block">
        <h2 class="uppgifter__block-title">Välj Tilläggstjänst</h2>
        <p class="uppgifter__block-subtitle">Välj den organisation du vill stödja. Du kan när som helst ändra ditt val på Mina Sidor. Ditt stöd gör stor skillnad!</p>
        <label class="uppgifter__field-wrapper">
          <input type="checkbox" v-model="$root.barncancerfonden" class="uppgifter__field">
          <span class="uppgifter__field-content">
            <span class="uppgifter__field-label uppgifter__field-label--with-info">
              <span class="uppgifter__field-label-text">Barncancerfonden</span>
              <span class="uppgifter__field-label-info">10 kr/mån</span>
            </span>
          </span>
        </label>
        <label class="uppgifter__field-wrapper">
          <input type="checkbox" v-model="$root.miljoval" class="uppgifter__field">
          <span class="uppgifter__field-content">
            <span class="uppgifter__field-label uppgifter__field-label--with-info">
              <span class="uppgifter__field-label-text">Bra Miljöval</span>
              <span class="uppgifter__field-label-info">25 kr/mån</span>
            </span>
          </span>
        </label>
        <div class="uppgifter__field-wrapper uppgifter__field-wrapper--price-monitor">
          <input type="checkbox" v-model="$root.prisbevakning" id="prisbevakning" class="uppgifter__field">
          <div class="uppgifter__field-content">
            <label for="prisbevakning" class="uppgifter__field-label uppgifter__field-label--with-info">
              <span class="uppgifter__field-label-text">Prisbevakning</span>
              <span class="uppgifter__field-label-info">10 kr/mån</span>
            </label>
            <div class="uppgifter__field-extra" v-if="$root.prisbevakning">
              <h3 class="uppgifter__price-monitor-title">Önskad prisbevakningsnivå?</h3>
              <label class="checkbox">
                <input type="radio" v-model="$root.prisbevakning_option" name="prisbevakning_option" value="35" required class="checkbox__field">
                <span class="checkbox__label">35 öre/kWh exkl. moms (43,75 öre inkl.moms)</span>
              </label>
              <label class="checkbox">
                <input type="radio" v-model="$root.prisbevakning_option" name="prisbevakning_option" value="40" required class="checkbox__field">
                <span class="checkbox__label">40 öre/kWh exkl. moms (50,00 öre inkl.moms)</span>
              </label>
              <label class="checkbox">
                <input type="radio" v-model="$root.prisbevakning_option" name="prisbevakning_option" value="45" required class="checkbox__field">
                <span class="checkbox__label">45 öre/kWh exkl. moms (56,25 öre inkl.moms)</span>
              </label>
              <label class="checkbox">
                <input type="radio" v-model="$root.prisbevakning_option" name="prisbevakning_option" value="50" required class="checkbox__field">
                <span class="checkbox__label">50 öre/kWh exkl. moms (62,50 öre inkl.moms)</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="step-nav">
        <button type="submit" class="button button--with-icon step-nav__button">Mina uppgifter 2 av 2 <Arrow /></button>
      </div>
    </form>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import { sv } from 'vuejs-datepicker/dist/locale'
function pad(value) {
  const _value = parseInt(value, 10);
  return (_value < 10 && _value > 0) ? '0' + _value : value;
}
export default {
  data() {
    return {
      sv,
      asap: this.$root.asap,
    }
  },
  watch: {
    asap(n) {
      this.$root.asap = n;
      if (!n && !this.$root.start) {
        this.$nextTick(() => {
          this.$refs.calendarAction.click();
        });
      }
    }
  },
  methods: {
    submit() {
      this.$router.push({ name: 'uppgifter2' })
    }
  },
  computed: {
    start_text() {
      let text = '';
      if (this.$root.start && (this.$root.start instanceof Date)) {
        text = [this.$root.start.getFullYear(), pad(this.$root.start.getMonth() + 1), pad(this.$root.start.getDate())].join('-');
      }
      return text;
    }
  },
  components: {
    Datepicker
  }
}
</script>
<style lang="scss">
  .uppgifter {
    &__title {
      text-align: center;
      margin: 0 0 rem(30);
      @include font-primary;
      @include media('>lg') {
        font-size: rem(26);
      }
      @include media('<=lg') {
        font-size: rem(22);
        line-height: (36/22);
      }
    }
    &__block {
      margin-bottom: rem(40);
    }
    &__block-title {
      @include font-primary(bold);
      color: $secondary-text-color;
      margin: 0 0 rem(6);
      font-size: rem(18);
    }
    &__block-subtitle {
      @include font-primary(roman);
      margin: 0;
      margin: 0 0 rem(16);
      font-size: rem(16);
    }
    &__field-wrapper {
      position: relative;
      display: block;
      margin-bottom: rem(16);
    }
    &__field {
      position: absolute;
      opacity: 0;
    }
    &__field-content {
      border: 1px solid $light-border-color;
      border-radius: 3px;
      display: block;
    }
    &__field:focus + &__field-content,
    &__field-content:hover {
      border-color: $dark-border-color;
    }
    &__field:checked + &__field-content {
      border-color: $primary-color;
      border-width: 2px;
    }
    &__field-label {
      display: block;
      @include font-primary;
      font-size: rem(18);
      padding: rem(19);
      &--with-info {
        display: flex;
      }
    }
    &__field-label-text {
      flex: 1 1;
    }
    &__field-label-info {
      font-size: rem(16);
    }
    &__field:checked + &__field-content &__field-label {
      @include font-primary(bold);
    }
    &__field-wrapper--asap-false &__field-content {
      display: flex;
      align-items: center;
    }
    &__field-wrapper--asap-false &__field-label {
      flex: 1 1;
    }
    &__field-wrapper--asap-false &__field-extra {
      position: relative;
      z-index: 1;
      right: rem(16);
    }
    &__calendar-wrapper {
      display: inline-block;
    }
    &__calendar#{&}__calendar { // double class to have more specificity than default styles
      right: 0;
      top: 0;
      padding: 1em;
      border: 0;
      box-shadow: 0 0 8px 3px rgba(0, 0, 0, 0.06);
      color: $secondary-text-color;
      header {
        @include font-primary(bold);
        font-size: 1em;
      }
      .cell {
        &.day {
          @include font-primary(roman);
          position: relative;
          z-index: 1;
          font-size: ((13/18) * 1em);
          border: 1px solid;
          margin: -1px 0 0 -1px;
          width: calc((100% / 7) + 1px);
          &.blank {
            border-color: transparent;
          }
          &:not(.disabled):not(.blank):hover {
            border-color: $primary-color;
            z-index: 2;
          }
        }
        &.selected {
          background-color: $primary-color;
          border-color: $primary-color;
          color: #fff;
          z-index: 2;
        }
        &.disabled {
          color: $light-border-color;
        }
        &.day-header {
          font-size: ((11/18) * 1em);
        }
      }
    }
    &__calendar-action {
      display: inline-block;
      line-height: 1;
      svg {
        display: inline-block;
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 0.6rem;
        vertical-align: -0.2rem;
      }
    }
    &__date-field {
      opacity: 0;
      position: absolute;
      right: 0;
    }
    &__price-monitor-title {
      @include font-primary(bold);
      font-size: rem(16);
      margin: 0;
      color: $secondary-text-color;
    }
    &__field-wrapper--price-monitor &__field-extra {
      padding: 0 rem(19) rem(19);
    }
  }
</style>
